import RoundedButton from 'components/RoundedButton';
import React from 'react';

const CSS = require('./BookBlockButton.module.scss');

interface BookBlockButtonProps {
  onClick: () => void;
  children: React.ReactNode;
}

function BookBlockButton({ onClick, children }: BookBlockButtonProps) {
  return (
    <RoundedButton
      jade
      size="L"
      fullWidth
      edgeRounding="medium"
      className={CSS.BookButton}
      onClick={onClick}
      data-test-id="BookButton"
    >
      {children}
    </RoundedButton>
  );
}

export default BookBlockButton;
